import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import RequestQuoteLanding from "../views/RequestQuoteLanding";
import { Helmet } from "react-helmet-async";

export default function RequestQuote(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <RequestQuoteLanding />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  //return desired view
  return (
    <>
      <Helmet>
        <title>Request Quote | Group V Limited</title>
        <meta
          name="description"
          content="Request a quote for our construction projects and services in Tanzania."
        />
        <meta property="og:title" content="Request Quote | Group V Limited" />
        <meta
          property="og:description"
          content="Get a quote for our construction projects and services in Tanzania."
        />
        <meta
          property="og:url"
          content="https://groupv.co.tz/#/request_quote"
        />
      </Helmet>
      {view}
    </>
  );
}
